module.exports = __webpack_public_path__ + "img/MA3D-Mini.caf88119.png";